import React, { useState } from 'react'
import styled from 'styled-components'
import { RiArrowUpSLine } from 'react-icons/ri'
import { MdKeyboardArrowRight } from 'react-icons/md'
import { helpData } from 'src/components/HomePage/ModalsContent/Help/helpData'

const Container = styled.div``

const ContentWrapper = styled.div`
  margin-bottom: 10px;
`

const Wrap = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding-right: 10px;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid #eff0f2;
  box-sizing: border-box;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  transition: all ease-in-out 0.6s;
  cursor: pointer;
  .p-title {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.05px;
    color: #333333;
  }
  .arrow {
    cursor: pointer;
  }

  .img_title_wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 120px;

    img {
      padding-left: 10px;
    }
  }
`

const Content = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid #eff0f2;
  box-sizing: border-box;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.06);
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;

  .link {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.navyBlue};
  }
`

const HelpAccordion = () => {
  const [clicked, setClicked] = useState<any>()

  const toggle = (index: any) => {
    if (clicked === index) {
      return setClicked(null)
    }
    setClicked(index)
  }

  return (
    <Container>
      {helpData.map((item, index): any => {
        return (
          <ContentWrapper>
            <Wrap onClick={() => toggle(index)} key={index}>
              <div className="img_title_wrapper">
                <img src={item.img} alt="" />
                <p className="p-title">{item.title}</p>
              </div>
              <p className="arrow">
                {clicked === index ? (
                  <RiArrowUpSLine />
                ) : (
                  <MdKeyboardArrowRight />
                )}
              </p>
            </Wrap>
            {clicked === index ? (
              <Content>
                <a
                  href={item.linkAdd}
                  className="link"
                  target="_blank"
                  rel="noreferrer"
                >
                  {item.linkAdd}
                </a>
              </Content>
            ) : null}
          </ContentWrapper>
        )
      })}
    </Container>
  )
}

export default HelpAccordion
